import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";
import { useSeo } from "@/hooks/useSeo";
import { Building2 } from "lucide-react";

const H2 = ({ children }) => (
  <h2 className="font-display text-xl sm:text-2xl font-semibold text-emerald-900 mt-10 mb-3">{children}</h2>
);
const P = ({ children }) => <p className="text-stone-700 leading-relaxed mb-3">{children}</p>;

export default function Impressum() {
  useSeo(
    "Impressum – LAIzyones",
    "Impressum von LAIzyones (Inhaber David Ehrle) – Anbieter der Softwarelösung LAIzyDocu. Angaben gemäß § 5 DDG.",
  );

  return (
    <div className="min-h-screen bg-stone-50 text-stone-900" data-testid="impressum-page">
      <SiteNav />

      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-20 pb-6">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-50 text-emerald-800 text-sm font-medium">
          <Building2 className="w-4 h-4" /> Rechtliches
        </span>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-emerald-900 leading-[1.05] mt-6">
          Impressum
        </h1>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 pb-20">
        <div className="bg-white rounded-[2rem] border border-stone-100 shadow-[0_20px_60px_rgb(0,0,0,0.05)] p-7 md:p-12 text-base">

          <H2>Angaben gemäß § 5 DDG</H2>
          <div className="rounded-2xl bg-stone-50 border border-stone-100 p-6 mb-2 leading-relaxed text-stone-700">
            <p className="font-semibold text-emerald-900">LAIzyones</p>
            <p>Einzelunternehmen</p>
            <p className="mt-3"><span className="font-semibold">Inhaber:</span> David Ehrle</p>
            <p className="mt-3">Ferdinand-Lentjes-Straße 32<br />39167 Wellen<br />Deutschland</p>
          </div>

          <H2>Kontakt</H2>
          <P>
            Telefon: 0179 7615911<br />
            E-Mail: <a href="mailto:info@laizyones.de" className="text-emerald-700 underline">info@laizyones.de</a><br />
            Website: <a href="https://laizyones.de" target="_blank" rel="noreferrer" className="text-emerald-700 underline">https://laizyones.de</a>
          </P>

          <H2>Umsatzsteuer- / Wirtschafts-Identifikation</H2>
          <P>
            Wirtschafts-Identifikationsnummer: DE459919567<br />
            Steuernummer: 105/215/02350<br />
            Finanzamt Magdeburg
          </P>

          <H2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H2>
          <P>
            David Ehrle<br />
            Ferdinand-Lentjes-Straße 32<br />
            39167 Wellen
          </P>

          <H2>Operative Projektleitung</H2>
          <P>Philipp-Arsim Nuraj</P>

          <H2>Softwarelösung</H2>
          <P>
            Die über diese Website angebotene Software (LAIzyDocu) ist ein Produkt und eine Marke von
            <strong> LAIzyones</strong>. Sämtliche Rechte an der Software, ihren Funktionen, Designs und Marken
            verbleiben bei LAIzyones.
          </P>

          <H2>Hinweis zur Streitbeilegung</H2>
          <P>
            Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" className="text-emerald-700 underline">
              https://ec.europa.eu/consumers/odr
            </a>. LAIzyones ist nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen. Das Angebot richtet sich ausschließlich an gewerbliche Kunden.
          </P>

          <p className="text-sm text-stone-500 mt-8">Stand: Juni 2026</p>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}
